const config = {
    apiKey: process.env.REACT_APP_TMDB_API_KEY,
};

export default config;
